import React, {useState, useCallback, useEffect, useContext} from "react";
import {useNavigate, Outlet} from "react-router-dom";
import "../../styles/component/layout/layout.scss"
import {logout} from "../../services/tokenService";
import {toast} from "react-toastify";
import UserLoginContext from "../../context/userLoginContext";
import NavigationMenu from "../../page-components/navbar/navbar";
import Header from "../../page-components/header/header";

export default function MainLayout() {
    const {setUser} = useContext(UserLoginContext);
    const [mobileNavOpen, setMobileNavOpen] = useState<boolean>(false);
    const [activePath, setActivePath] = useState<string>(() => {
        return window.location.pathname || "/dashboard";
    });

    const navigate = useNavigate();

    const handleNavigate = useCallback((path: string) => {
        setActivePath(path);
        if (window.location.pathname !== path) {
            window.history.pushState({}, "", path);
        }
        // window.history.pushState({}, "", path);
        navigate(path);
        setMobileNavOpen(false);
    }, []);

    const handleLogout = useCallback(async () => {
        logout();
        setUser?.({
            loginStatus: false,
            id: "",
            email: "",
            name: {firstName: "", lastName: ""},
            roles: [],
            profileURL: "",
            isAdmin: false
        });
        toast.success("User Logged Out Successfully!", {autoClose: 1500});
        navigate("/login", {replace: true});
    }, []);

    // Handle browser back/forward buttons
    useEffect(() => {
        const handlePopState = () => {
            setActivePath(window.location.pathname);
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, []);

    return (
        <div className={`hrms-app pn-layout${mobileNavOpen ? " pn-layout--nav-open" : ""}`}>
            <button
                className="pn-layout__nav-backdrop"
                type="button"
                aria-label="Close navigation menu"
                onClick={() => setMobileNavOpen(false)}
            />

            <NavigationMenu
                activePath={activePath}
                onNavigate={handleNavigate}
                mobileOpen={mobileNavOpen}
                onMobileClose={() => setMobileNavOpen(false)}
            />

            <div className="pn-content">
                <Header
                    onNavigate={handleNavigate}
                    onLogout={handleLogout}
                    onMenuToggle={() => setMobileNavOpen(true)}
                />

                <main className="pn-main">
                    {/*<div className="pn-card">*/}
                    {/*    <h2 className="pn-card__title">Complete Navigation System</h2>*/}
                    {/*    <p className="pn-card__body">*/}
                    {/*        This is a fully functional navigation system with role-based access control,*/}
                    {/*        theme switching (5 colors × 2 modes), and a user dropdown menu.*/}
                    {/*        Current route: <strong>{activePath}</strong>*/}
                    {/*    </p>*/}
                    {/*</div>*/}

                    {/*<div className="pn-card">*/}
                    {/*    <h2 className="pn-card__title">Role Switcher</h2>*/}
                    {/*    <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>*/}
                    {/*        <button*/}
                    {/*            className={`pn-role-btn${role === "ADMIN" ? " pn-role-btn--active" : ""}`}*/}
                    {/*            onClick={() => setRole("ADMIN")}*/}
                    {/*        >*/}
                    {/*            Switch to ADMIN*/}
                    {/*        </button>*/}
                    {/*        <button*/}
                    {/*            className={`pn-role-btn${role === "EMPLOYEE" ? " pn-role-btn--active" : ""}`}*/}
                    {/*            onClick={() => setRole("EMPLOYEE")}*/}
                    {/*        >*/}
                    {/*            Switch to EMPLOYEE*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*    <p className="pn-card__body" style={{ marginTop: "12px", fontSize: "13px" }}>*/}
                    {/*        Switch roles to see how the navigation menu and user dropdown adapt based on permissions.*/}
                    {/*    </p>*/}
                    {/*</div>*/}
                    {/*<Content className='main-section'><Outlet/></Content>*/}
                    <Outlet/>
                </main>
            </div>
        </div>
    );
}
